import { render } from "./LeaveEntitlementReport.vue?vue&type=template&id=1b2a0072&scoped=true"
import script from "./LeaveEntitlementReport.vue?vue&type=script&lang=js"
export * from "./LeaveEntitlementReport.vue?vue&type=script&lang=js"

import "./leave-entitlement-report.scss?vue&type=style&index=0&id=1b2a0072&lang=scss&scoped=true"

import exportComponent from "/var/www/html/HR/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2a0072"]])

export default __exports__